<template>
  <v-banner color="white">
    <template v-slot:icon>
      <v-avatar
        color="blue darken-2"
        size="40"
      >
        <v-icon color="white">person_search</v-icon>
      </v-avatar>
    </template>

    There are no profiles available

    <template v-slot:actions>
      <v-btn
        text
        color="blue darken-2"
        @click="$emit('add-profile')"
      >
        Add profile
      </v-btn>
    </template>
  </v-banner>
</template>

<script>
export default {
  name: 'NoProfilesBanner',
};
</script>
